import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import ModalBase from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

const Paper = styled.div`
    width: 100%;
    padding: 1.25rem;
    max-width: 31.25rem;
    max-height: 31.25rem;
    background-color: #ffffff;
    overflow-y: scroll;
    border-radius: 0.25rem;
`;

const UnstyledModal = ({ open, className, children, ...otherProps }) => (
    <ModalBase
        className={className}
        aria-labelledby="license-information"
        open={open}
        {...otherProps}
        BackdropComponent={Backdrop}
        closeAfterTransition
    >
        <Fade in={open}>
            <Paper>{children}</Paper>
        </Fade>
    </ModalBase>
);

UnstyledModal.propTypes = {
    className: PropTypes.string,
    open: PropTypes.bool.isRequired
};

const modalStyles = css`
    display: flex;
    align-items: center;
    justify-content: center;
    /* had to use !important here because
    Material-UI uses inline styles */
    z-index: 10000 !important;
`;

export const Modal = styled(UnstyledModal)`
    ${modalStyles}
`;
